// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAMQnHbX11u_RJFDsGzwJ4xedb-6FRcMXM",
  authDomain: "mutual-3b6ad.firebaseapp.com",
  projectId: "mutual-3b6ad",
  storageBucket: "mutual-3b6ad.firebasestorage.app",
  messagingSenderId: "257566841799",
  appId: "1:257566841799:web:f4adf217eac7fc4b2317e2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const guardarComprobante = async (comprobante) => {
    try {
      // Obtén la colección donde quieres guardar los datos (puedes cambiar el nombre de la colección)
      const comprobantesRef = collection(db, "comprobantes");
      
      // Añadir el comprobante a Firestore
      const docRef = await addDoc(comprobantesRef, comprobante);
      console.log("Comprobante guardado con ID: ", docRef.id);
    } catch (e) {
      console.error("Error al guardar el comprobante: ", e);
    }
  };

  export { db, guardarComprobante }